import React from 'react';

const RequiredLabel = (): JSX.Element => (
  <span style={{ opacity: 0.6, fontSize: '0.95rem', fontWeight: 'normal' }}>(required)</span>
);

export default RequiredLabel;
